import {
    app,
    Component,
    ojs,
    each,
    component,
    v,
    state,
    payload,
} from "modular-openscriptjs";
import { getStore, store, deepEqual, clearSearchSuggestion, authenticated } from "../../../helpers";
import { api, dc } from "../../../declarations";

import TopCategoryView from "./TopCategoryView";
import FrequentlyOrderedProductView from "./FrequentlyOrderedProductView";
import FeaturedBusinessView from "../Businesses/FeaturedBusinessView";
import QuickOrderCard from "./QuickOrderCard";
import SearchResultProductView from "../../Views/SearchResultProductView";
import BsIcon from "../../Blocks/BsIcon";

const h = app("h");

ojs(
    TopCategoryView,
    FrequentlyOrderedProductView,
    FeaturedBusinessView,
    QuickOrderCard,
    SearchResultProductView,
    BsIcon
);

export default class SearchDefault extends Component {
    categoriesFetched = state(false);
    frequentlyOrderedProductsFetched = state(false);
    featuredBusinessesFetched = state(false);
    _featuredBusinessesFetching = false;

    render(...args) {
        return h.div(
            {
                class: "container pt-3 py-5 mb-5 py-md-5",
            },

            // Main Categories Section
            h.div(
                { class: "mb-5" },
                h.h4({ class: "fw-bold mb-4 px-1" }, "Main Categories"),

                v(dc.categories, (categories) => {
                    return h.div(
                        {
                            class: "d-flex flex-nowrap overflow-x-auto pb-3 gap-3 desktop-scrollbar",
                            hook: "frequently_ordered_holder",
                        },
                        h.call(() => {
                            if (
                                this.categoriesFetched.value &&
                                categories.value.length === 0
                            ) {
                                return h.div(
                                    {
                                        class: "card border-0 shadow-sm rounded-4 w-100 p-4 text-center bg-white",
                                    },
                                    h.div(
                                        {
                                            class: "text-muted d-flex align-items-center gap-2",
                                        },
                                        h.i({
                                            class: "fas fa-folder-open fa-2x d-block opacity-25",
                                        }),
                                        h.span("No categories found"),
                                    ),
                                );
                            }

                            if (categories.value.length === 0) {
                                return each(
                                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                                    () =>
                                        h.div(
                                            {
                                                class: "flex-shrink-0 bg-light placeholder-glow",
                                                style: "width: 140px; height: 140px;",
                                            },
                                            h.div({
                                                class: "placeholder rounded-4",
                                                style: "width: 100%; height: 100%;",
                                            }),
                                        ),
                                );
                            }

                            return each(categories.value, (cat) =>
                                h.div(
                                    {
                                        class: "flex-shrink-0",
                                        style: "width: 140px;",
                                    },
                                    h.TopCategoryView(cat),
                                ),
                            );
                        }),
                    );
                }),
            ),

            // Featured Businesses Section
            h.div(
                { class: "mb-5" },
                h.div(
                    {
                        class: "d-flex gap-3 mb-4 px-1 justify-content-between align-items-center",
                    },
                    h.h4({ class: "fw-bold" }, "Featured Businesses"),
                    h.span(
                        {
                            class: "text-primary",
                            role: "button",
                            onclick: h.func("app('router').to", "companies.list"),
                        },
                        h.span(
                            { class: "d-flex gap-1 align-items-center" },
                            h.span("All"),
                            h.BsIcon("chevron-right"),
                        ),
                    ),
                ),

                v(this.featuredBusinessesFetched, (fetched) => {
                    if (
                        fetched.value &&
                        dc.featuredBusinesses.value.length === 0
                    ) {
                        return h.div(
                            {
                                class: "card border-0 shadow-sm rounded-4 w-100 p-4 text-center bg-white",
                            },
                            h.div(
                                {
                                    class: "text-muted d-flex align-items-center gap-2",
                                },
                                h.i({
                                    class: "fas fa-store-slash fa-2x d-block opacity-25",
                                }),
                                h.span("No businesses to show for now"),
                            ),
                        );
                    }

                    return v(dc.featuredBusinesses, (businesses) => {
                        return h.div(
                            {
                                class: "d-flex flex-nowrap overflow-x-auto pb-3 gap-3 desktop-scrollbar",
                                hook: "frequently_ordered_holder",
                            },
                            h.call(() => {
                                if (businesses.value.length === 0) {
                                    return each(
                                        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                                        () =>
                                            h.div(
                                                {
                                                    class: "flex-shrink-0 bg-light placeholder-glow",
                                                    style: "width: 280px; height: 140px;",
                                                },
                                                h.div({
                                                    class: "placeholder rounded-4",
                                                    style: "width: 100%; height: 100%;",
                                                }),
                                            ),
                                    );
                                }

                                return each(businesses.value, (business) =>
                                    h.div(
                                        {
                                            class: "flex-shrink-0",
                                        },
                                        h.FeaturedBusinessView(business),
                                    ),
                                );
                            }),
                        );
                    });
                }),
            ),

            // Frequently Ordered Section
            h.div(
                { class: "mb-5" },
                h.h4({ class: "fw-bold mb-4 px-1" }, "Order Them Again"),
                v(this.frequentlyOrderedProductsFetched, (fetched) => {
                    if (
                        fetched.value &&
                        dc.frequentlyOrderedProducts.value.length === 0
                    ) {
                        return h.div(
                            {
                                class: "card border-0 shadow-sm rounded-4 w-100 p-4 text-center bg-white",
                            },
                            h.div(
                                {
                                    class: "text-muted d-flex align-items-center gap-2",
                                },
                                h.i({
                                    class: "fas fa-shopping-basket fa-2x d-block opacity-25",
                                }),
                                h.span("Place your first order"),
                            ),
                        );
                    }

                    return v(dc.frequentlyOrderedProducts, (products) => {
                        return h.div(
                            {
                                class: "d-flex flex-nowrap overflow-x-auto pb-3 gap-3 desktop-scrollbar",
                                hook: "frequently_ordered_holder",
                            },
                            h.call(() => {
                                if (products.value.length === 0) {
                                    return each(
                                        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                                        () =>
                                            h.div(
                                                {
                                                    class: "flex-shrink-0 bg-light placeholder-glow",
                                                    style: "width: 280px; height: 120px;",
                                                },
                                                h.div({
                                                    class: "placeholder rounded-4",
                                                    style: "width: 100%; height: 100%;",
                                                }),
                                            ),
                                    );
                                }

                                return each(products.value, (product) =>
                                    h.SearchResultProductView(product, {
                                        class: "flex-shrink-0 h-100",
                                        style: "width: 180px;",
                                        listeners: {
                                            click: () => {
                                                app("broker").send(
                                                    app("$e").product.needs
                                                        .display,
                                                    payload({ product }),
                                                );
                                            },
                                        },
                                    }),
                                );
                            }),
                        );
                    });
                }),
            ),

            // Quick Order Section
            h.div(h.QuickOrderCard()),
            ...args,
        );
    }

    $_mounted(componentId) {
        let c = component(componentId);

        if (!c) return;

        c.getCategories();
        c.getFrequentlyOrderedProducts();
        c.getFeaturedBusinesses();
        clearSearchSuggestion();
    }

    async getCategories() {
        if (this.categoriesFetched.value) return;

        // Load from cache first
        if (dc.categories.value.length === 0) {
            let cached = await getStore("categories");
            if (cached) {
                dc.categories.value = cached;
            }
        }

        let res = await api.get("/categories/top", {}, { silent: true });

        this.categoriesFetched.value = true;

        if (!res) return;

        let categories = res.data.categories;

        // Revalidate
        if (!deepEqual(categories, dc.categories.value)) {
            dc.categories.value = categories;
            store("categories", JSON.stringify(categories));
        }
    }

    async getFeaturedBusinesses() {
        // Guard against $_mounted firing more than once: bail out
        // immediately (synchronously, before any await) if a fetch is
        // already in flight or has already completed, so a second
        // concurrent call can't slip past the check below and refetch.
        if (this.featuredBusinessesFetched.value || this._featuredBusinessesFetching) {
            return;
        }
        this._featuredBusinessesFetching = true;

        // Load from cache first
        if (dc.featuredBusinesses.value.length === 0) {
            let cached = await getStore("featured_businesses");
            if (cached) {
                dc.featuredBusinesses.value = cached;
            }
        }

        let params = {};
        let lat = dc.latitude || (await getStore("latitude"));
        let lng = dc.longitude || (await getStore("longitude"));

        if (lat && lng) {
            params.latitude = lat;
            params.longitude = lng;
        }

        let res = await api.get("/users/featured-businesses", params, {
            silent: true,
        });

        this.featuredBusinessesFetched.value = true;
        this._featuredBusinessesFetching = false;

        if (!res) return;

        let businesses = res.data.businesses.data;

        // Revalidate
        if (!deepEqual(businesses, dc.featuredBusinesses.value)) {
            dc.featuredBusinesses.value = businesses;
            store("featured_businesses", JSON.stringify(businesses));
        }
    }

    async getFrequentlyOrderedProducts() {
        if (this.frequentlyOrderedProductsFetched.value) return;

        let now = Date.now();
        let cacheTime = await getStore("frequently_ordered_products_timestamp");
        let isCacheValid = false;

        if (cacheTime) {
            let ageInDays = (now - parseInt(cacheTime)) / (1000 * 60 * 60 * 24);
            if (ageInDays < 3) {
                isCacheValid = true;
            }
        }

        // Load from cache first if valid
        if (isCacheValid && dc.frequentlyOrderedProducts.value.length === 0) {
            let cached = await getStore("frequently_ordered_products");
            if (cached) {
                dc.frequentlyOrderedProducts.value = cached;
            }
        }

        // Personal order history - nothing to fetch for guests.
        if (!authenticated()) return;

        let res = await api.get(
            "/users/frequently-ordered-products",
            {},
            { silent: true },
        );

        this.frequentlyOrderedProductsFetched.value = true;

        if (!res) return;

        let products = res.data.products;

        // Revalidate
        if (!deepEqual(products, dc.frequentlyOrderedProducts.value)) {
            dc.frequentlyOrderedProducts.value = products;
            store("frequently_ordered_products", JSON.stringify(products));
            store("frequently_ordered_products_timestamp", now.toString());
        }
    }
}

ojs(SearchDefault);
